export default __webpack_public_path__ + "static/media/benevity-logo.08c1fd7e.png";